<template>
    <div class="incident-history-accordion">
        <div v-if="changes && changes.length > 0">
            <b-card v-for="(change, index) in changes" :key="index" no-body class="mb-1">
                <b-card-header header-tag="header" role="tab" class="p-1 cursor-pointer" v-b-toggle="`collapse-${index}`">
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <div class="flex-grow-1">
                            <div class="row">
                                <div class="col-4">
                                    <small class="text-muted d-block">Tarih & İşlemi Yapan</small>
                                    <p class="font-weight-bold mb-0 text-nowrap text-truncate" :title="`${change.ChangeDateStr || 'N/A'} - ${change.UserFullName || 'N/A'}`">
                                        {{ change.ChangeDateStr || "N/A" }} - {{ change.UserFullName || "N/A" }}
                                    </p>
                                </div>
                                <div class="col-2">
                                    <small class="text-muted d-block">Değişiklik Uygulandı</small>
                                    <p class="font-weight-bold mb-0 text-nowrap text-truncate" :title="`${change.ChangeDateStr || 'N/A'} - ${change.UserFullName || 'N/A'}`">
                                        {{ change.Applied ? "EVET" :" HAYIR" || "N/A" }}
                                    </p>
                                </div>
                                <div class="col-6">
                                    <small class="text-muted d-block">Açıklama</small>
                                    <p class="font-weight-bold mb-0 text-nowrap text-truncate" :title="change.ChangeDescription || '-'">
                                        {{ change.ChangeDescription || "-" }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="ml-1"><feather-icon icon="ChevronDownIcon" size="20" class="text-muted" /></div>
                    </div>
                </b-card-header>

                <b-collapse :id="`collapse-${index}`" accordion="incident-history-accordion" role="tabpanel">
                    <b-card-body class="p-1 border-top">
                        <table v-if="hasFieldChanges(change)" class="table table-bordered table-sm mb-0 mt-0">
                            <thead class="thead-light">
                                <tr>
                                    <th>Değişen Alan</th>
                                    <th>Eski Değer</th>
                                    <th>Yeni Değer</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="change.OldCompanyAmount !== change.NewCompanyAmount">
                                    <td>Firma Tutarı</td>
                                    <td>
                                        <b-badge variant="light" class="border border-primary text-primary">{{ change.OldCompanyAmountStr }}</b-badge>
                                    </td>
                                    <td>
                                        <b-badge
                                            variant="light"
                                            :class="change.NewCompanyAmount > change.OldCompanyAmount ? 'border border-success text-success' : 'border border-warning text-warning'"
                                        >
                                            {{ change.NewCompanyAmountStr }}
                                        </b-badge>
                                    </td>
                                </tr>
                                <tr v-if="change.OldEmployeeAmount !== change.NewEmployeeAmount">
                                    <td>Sürücü Tutarı</td>
                                    <td>
                                        <b-badge variant="light" class="border border-primary text-primary">{{ change.OldEmployeeAmountStr }}</b-badge>
                                    </td>
                                    <td>
                                        <b-badge
                                            variant="light"
                                            :class="change.NewEmployeeAmount > change.OldEmployeeAmount ? 'border border-success text-success' : 'border border-warning text-warning'"
                                        >
                                            {{ change.NewEmployeeAmountStr }}
                                        </b-badge>
                                    </td>
                                </tr>
                                <tr v-if="change.OldEmployeeDepositAmount !== change.NewEmployeeDepositAmount">
                                    <td>Sürücü Emanet Tutarı</td>
                                    <td>
                                        <b-badge variant="light" class="border border-primary text-primary">{{ change.OldEmployeeDepositAmountStr }}</b-badge>
                                    </td>
                                    <td>
                                        <b-badge
                                            variant="light"
                                            :class="change.NewEmployeeDepositAmount > change.OldEmployeeDepositAmount ? 'border border-success text-success' : 'border border-warning text-warning'"
                                        >
                                            {{ change.NewEmployeeDepositAmountStr }}
                                        </b-badge>
                                    </td>
                                </tr>
                                <tr v-if="change.InstallmentCountChanged">
                                    <td>Taksit Sayısı</td>
                                    <td>
                                        <b-badge variant="light" class="border border-primary text-primary">{{ change.OldInstallmentCount }}</b-badge>
                                    </td>
                                    <td>
                                        <b-badge
                                            variant="light"
                                            :class="change.NewInstallmentCount > change.OldInstallmentCount ? 'border border-success text-success' : 'border border-warning text-warning'"
                                        >
                                            {{ change.NewInstallmentCount }}
                                        </b-badge>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else class="text-center p-0 text-muted">Herhangi bir değişiklik yapılmamıştır.</div>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
        <div v-else>
            <p class="text-center">Bu vukuat için bir değişiklik geçmişi bulunamadı.</p>
        </div>
    </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCollapse, VBToggle, BBadge } from "bootstrap-vue";

export default {
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BCollapse,
        BBadge,
    },
    directives: {
        "b-toggle": VBToggle,
    },
    props: {
        changes: {
            type: Array,
            required: true,
        },
    },
    methods: {
        hasFieldChanges(change) {
            const companyAmountChanged = change.OldCompanyAmount !== change.NewCompanyAmount;
            const employeeAmountChanged = change.OldEmployeeAmount !== change.NewEmployeeAmount;
            const depositAmountChanged = change.OldEmployeeDepositAmount !== change.NewEmployeeDepositAmount;
            const installmentCountChanged = change.InstallmentCountChanged;

            return companyAmountChanged || employeeAmountChanged || depositAmountChanged || installmentCountChanged;
        },
    },
};
</script>
